import { Card } from "@mui/material";
import React, { ReactNode } from "react";

export type ObjectHistoryCardProps = {
    itemID?: number;
    children?: ReactNode;
};

export function ObjectHistoryCard({ itemID, children }: ObjectHistoryCardProps) {
    return (
        <Card data-itemid={itemID} variant="outlined">
            {children}
        </Card>
    );
}
